<template>
  <div class="associate-tags">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
      <svg class="icon" aria-hidden="true">
        <use xlink:href="#icon-a-shezhi2"></use>
      </svg>
    </breadcrumbs>
    <div class="content-wrapper">
      <!-- <div class="upload-button">
        <artmisads-select-button @click="onUpload">
         <Icon name="shangchuan-xi" style="margin-right: 8px;"></Icon>
          Upload
        </artmisads-select-button>
      </div> -->
      <artmisads-table :columns="columns" :data-source="data" :loading="loading"
        :pagination="false" >
        <template #bodyCell="{ column, text, record }">
          <template v-if="column.dataIndex === 'Marketplace'">
            <div class="marketplace-info">
              <Icon :name="countryCode(record.countryCode)?.icon"></Icon>
              {{ countryCode(record.countryCode)?.host }}
            
            </div>
          </template>
          <template v-if="column.dataIndex === 'tag'">
            <div class="tag-info">
              <a-tag color="blue" v-for="(tag,index) in record.associateTags.slice(0, 20)" :key="tag" >{{ tag }}</a-tag>
              <span v-if="record.associateTags.length >20">...</span>
            </div>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <span class="edit-btn-wrap">
              <span
                v-if="isStoreIdMissing(record)"
                class="edit-storeid-dot"
                aria-hidden="true"
              />
              <artmisads-select-button size="small" @click="onOpenModal(record)">
                Edit
              </artmisads-select-button>
            </span>
          </template>
        </template>
      </artmisads-table>
    </div>
    
    <!-- 编辑标签弹窗 -->
    <edit-model
      ref="editModelRef"
      @refresh="handleRefresh"
    />
    <upload-model
      ref="uploadModelRef"
      @save="handleSave"
    />
  </div>
</template>

<script setup>
import breadcrumbs from '@/components/breadcrumbs.vue'
import editModel from './components/editModel.vue'
import { ref, onMounted } from 'vue'
import { associateTagsApi } from '@/server/publisher/associateTags'
import { COUNTRY_BASE } from '~/contants/common'
import Icon from '~/components/Icon.vue'
import { message } from 'ant-design-vue'
import uploadModel from './components/uploadModel.vue'
const breadcrumbsData = {
  title: "Amazon StorelD",
  des: "Manage your Amazon StorelD",
  color: '#FFD358',
  links: [
    {
      name: "Home",
      path: "/operator/users",
    },
    {
      name: 'Settings',
      path: '/publisher/settings/profile',
    },
    {
      name: "Amazon StorelD",
      path: "/publisher/settings/associateTags",
    },
  ],
}
const columns = ref([
  {
    title: 'Marketplace',
    dataIndex: 'Marketplace',
    align: 'center',
    titleAlign: 'center',
  },
  // {
  //   title: 'Tags',
  //   dataIndex: 'tag',
  //   align: 'center',
  //   titleAlign: 'center',
  // },
  {
    title: 'StoreID',
    dataIndex: 'storeId',
    align: 'center',
    titleAlign: 'center',
  },
  {
    title: 'Action',
    dataIndex: 'action',
    align: 'center',
    titleAlign: 'center',
  }
])
const data = ref([])
const loading = ref(false)
const tableTotal = ref(0)
const params = ref({
  page: 1,
  size: 10,
})

// 编辑弹窗组件ref
const editModelRef = ref(null)
const uploadModelRef = ref(null)
const getData = () => {
  loading.value = true
  associateTagsApi.getAssociateAllTags(params.value).then(res => {
    data.value = res.data
    
    tableTotal.value = res.data.total
  }).finally(() => {
    loading.value = false
  })
}

const countryCode =(countryCode)=> {
  return COUNTRY_BASE.find(item => item.countryCode === countryCode)
}

const isStoreIdMissing = (record) => {
  const id = record?.storeId
  if (id == null) return true
  return String(id).trim() === ''
}

// 打开编辑Modal
const onOpenModal = (record) => {
  if (editModelRef.value) {
    editModelRef.value.open(record)
  }
}
const handleSave = () => {
  getData()
}
// 处理刷新列表事件
const handleRefresh = () => {
  getData()
 
}
const onUpload = () => {
  if (uploadModelRef.value) {
    uploadModelRef.value.open()
  }
}
onMounted(() => {
  getData()
})
</script>

<style scoped lang="less">
.associate-tags {
  padding: 16px;
  padding-top: unset;
  width: 100%;
  .content-wrapper{
    display: block !important;
    .upload-button{
      display: flex;
      justify-content: flex-end;
      margin-bottom: 16px;
    }
   .marketplace-info{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    .icon{
      width: 20px;
      height: 20px;
    }
   }
   .edit-btn-wrap {
    position: relative;
    display: inline-block;
   }
   .edit-storeid-dot {
    position: absolute;
    top: 1px;
    right: 1px;
    width: 8px;
    height: 8px;
    background: #ff4d4f;
    border-radius: 50%;
    transform: translate(40%, -40%);
    pointer-events: none;
    z-index: 1;
   }
  }
}
</style>